export default "__VITE_ASSET__B2g_8SRl__"